import api from "api";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";
import { queryKeys } from "utils/misc";

interface Patient {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  language_code?: string;
}

interface PatientsListResponse {
  items: Patient[];
}

export const usePatientsList = () => {
  const therapistId = useId();
  const key = queryKeys.patientsList(therapistId);

  return useQuery<Patient[]>(key, async () => {
    const response = await api("GET /messages/patients", {
      query: { therapist_id: therapistId },
    });
    const data: PatientsListResponse = await response.json();
    return data.items;
  });
};
